import api from 'lib/trpcClient';

export const useDataRoomRequests = (dataRoomId: string) => {
  const { data: queryData } = api.dataRoom.getById.useQuery({ id: dataRoomId });
  const { data: updateData, mutate: runUpdateMutation } =
    api.dataRoom.update.useMutation();

  const data = updateData ?? queryData;

  return {
    data,
    update: runUpdateMutation,
  };
};
